// import "./App.css";
// import "./i18n";
// import DrawerApp from "./components/DrawerApp";
// import Login from "./screens/login.screen";
// import { useStateContext } from "./context/ContextProvider";
// import ResetPassword from "./screens/ResetPassword";
// import DailyPopup from "./components/Reminder";
// import { CustomThemeProvider } from "./context/ThemeContext";
// import PatientsEarlyAppointmentCheckReminder from "./components/PatientsEarlyAppointmentCheckReminder";
// import NewIssueScreen from "./screens/new_issue.screen";


// export default function App() {
//   const { token, user } = useStateContext();

//   const currentPath = window.location.pathname;

//   if (currentPath === "/reset-password") {
//     return (
//       <CustomThemeProvider>
//         <ResetPassword />
//       </CustomThemeProvider>
//     );
//   }

//   if (!token) {
//     return (
//       <CustomThemeProvider>
//         <Login />
//       </CustomThemeProvider>
//     );
//   }

//   return (
//     <CustomThemeProvider>
//       <div className="App">
//         {(user?.user_role === "ADMIN" || user?.user_role === "STAFF") && (
//           <>
//             <DailyPopup />
//             <PatientsEarlyAppointmentCheckReminder />
//           </>
//         )}
//         <DrawerApp />
//       </div>
//     </CustomThemeProvider>
//   );
// }



// import "./App.css";
// import "./i18n";
// import DrawerApp from "./components/DrawerApp";
// import Login from "./screens/login.screen";
// import { useStateContext } from "./context/ContextProvider";
// import ResetPassword from "./screens/ResetPassword"; // This is your ResetPasswordConfirm screen
// import DailyPopup from "./components/Reminder";
// import { CustomThemeProvider } from "./context/ThemeContext";
// import PatientsEarlyAppointmentCheckReminder from "./components/PatientsEarlyAppointmentCheckReminder";
// import NewIssueScreen from "./screens/new_issue.screen";

// export default function App() {
//   const { token, user } = useStateContext();

//   // Get the path from the URL
//   const currentPath = window.location.pathname;

//   // ✅ 1. Check if the user is coming from an email link
//   // The link looks like: /reset-password/uid/token/
//   // We use .startsWith because the URL has dynamic IDs at the end
//   if (currentPath.startsWith("/reset-password")) {
//     return (
//       <CustomThemeProvider>
//         <ResetPassword />
//       </CustomThemeProvider>
//     );
//   }

//   // ✅ 2. Gatekeeper: If no token (not logged in), show Login
//   if (!token) {
//     return (
//       <CustomThemeProvider>
//         <Login />
//       </CustomThemeProvider>
//     );
//   }

//   // ✅ 3. Main Application: Only shows if user has a token (is logged in)
//   return (
//     <CustomThemeProvider>
//       <div className="App">
//         {/* Only Admin or Staff see the popups */}
//         {(user?.user_role === "ADMIN" || user?.user_role === "STAFF") && (
//           <>
//             <DailyPopup />
//             <PatientsEarlyAppointmentCheckReminder />
//           </>
//         )}
        
//         {/* The main dashboard and navigation */}
//         <DrawerApp />
//       </div>
//     </CustomThemeProvider>
//   );
// }

/////////////////////////////////////

import "./App.css";
import "./i18n";
import DrawerApp from "./components/DrawerApp";
import Login from "./screens/login.screen";
import { useStateContext } from "./context/ContextProvider";
import ResetPassword from "./screens/ResetPassword"; // This is your ResetPasswordConfirm screen
import DailyPopup from "./components/Reminder";
import { CustomThemeProvider } from "./context/ThemeContext";
// I kept the import below so the file reference stays valid, but we won't use it.
import PatientsEarlyAppointmentCheckReminder from "./components/PatientsEarlyAppointmentCheckReminder";
import NewIssueScreen from "./screens/new_issue.screen";

export default function App() {
  const { token, user } = useStateContext();

  // Get the path from the URL
  const currentPath = window.location.pathname;

  // ✅ 1. Check if the user is coming from an email link
  if (currentPath.startsWith("/reset-password")) {
    return (
      <CustomThemeProvider>
        <ResetPassword />
      </CustomThemeProvider>
    );
  }

  // ✅ 2. Gatekeeper: If no token (not logged in), show Login
  if (!token) {
    return (
      <CustomThemeProvider>
        <Login />
      </CustomThemeProvider>
    );
  }

  // ✅ 3. Main Application: Only shows if user has a token (is logged in)
  return (
    <CustomThemeProvider>
      <div className="App">
        {/* Only Admin or Staff see the popups */}
        {(user?.user_role === "ADMIN" || user?.user_role === "STAFF") && (
          <>
            {/* ✅ Both popups are now commented out to prevent any reminders on login */}
            {/* <DailyPopup /> */}
            {/* <PatientsEarlyAppointmentCheckReminder /> */}
          </>
        )}
        
        {/* The main dashboard and navigation */}
        <DrawerApp />
      </div>
    </CustomThemeProvider>
  );
}



